import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';
import { GenericBusinessCardStackContentViewModel } from './generic-business-card-stack-content-view-model';

@Component({
  selector: 'app-generic-business-card-stack-content',
  templateUrl: './generic-business-card-stack-content.component.html',
  styleUrls: ['./generic-business-card-stack-content.component.scss'],
  providers: [GenericBusinessCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenericBusinessCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: GenericBusinessCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
